import React from 'react'
import ExhibitorProfileLink from '../../../lib/components/ExhibitorProfileLink'
import { byProfession } from '../../functions/exhibitorViews'
import { LABELS } from '../../constants/staticText'
import { Ueberschrift } from '../../../lib/a11y/Ueberschrift'

// Flache Berufsliste, darunter die Aussteller — dieselbe Menge, andere Richtung.
const ProfessionsWithExhibitors = ({ data }) => {
    const professions = byProfession(data)

    if (0 === professions.length) return <p className="section-empty">{LABELS.noProfessions}</p>

    return (
        <ul className="section-professions">
            {professions.map(profession => (
                <li key={profession.id} className="profession-block">
                    <Ueberschrift className="profession-title">
                        {profession.title}{profession.specialization ? ` ${profession.specialization}` : ''}
                    </Ueberschrift>
                    <ul className="profession-exhibitors">
                        {profession.exhibitors.map(exhibitor => (
                            <li key={exhibitor.participantId}><ExhibitorProfileLink id={exhibitor.participantId}>{exhibitor.name}</ExhibitorProfileLink></li>
                        ))}
                    </ul>
                </li>
            ))}
        </ul>
    )
}

export default ProfessionsWithExhibitors
